<template>
  <v-dialog v-model="dialog" max-width="800px" @click:outside="close">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="{ ...dialog, ...tooltip }"
            small
            class="mr-2"
          >
            ri-file-list-line
          </v-icon>
        </template>

        Alterar permissões
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <v-spacer />

        <v-icon @click="close"> eva-close-outline </v-icon>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-row justify="end">
            <v-col>
               <v-select
                v-model="selectedUnitId"
                :items="units"
                item-text="name"
                item-value="id"
                label=" Selecione a Unidade"
                hide-details
                outlined
                dense
                placeholder="Selecione a unidade"
                :disabled="units.length === 0"
                required
                />
             </v-col>
            <v-col cols="auto">
              <v-btn @click="saveAllUserPermisssions" color="light-blue" dark :disabled="!selectedUnitId">
                <v-icon dark left> ri-checkbox-line </v-icon>
                Todas permissões
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="deleteAllUserPermisssions" color="secondary" dark :disabled="!selectedUnitId">
                <v-icon dark left> ri-checkbox-blank-line </v-icon>
                Remover todas permissões
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs
                v-model="tab"
                background-color="transparent"
                color="secondary"
              >
                <v-tab v-for="(value, key) in categories" :key="key">
                  {{ value }}
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="(value, key) in categories" :key="key">
                  <PermissionTab
                    :permissions="permissions"
                    :category="key"
                    :user="user"
                    :unitId="selectedUnitId"
                    :refreshUser="refreshUser"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PermissionTab from "./permission_tab.vue";

export default {
  props: {
    userId: String,
  },
  components: {
    PermissionTab,
  },
  data() {
    return {
      tab: null,
      dialog: false,
      selectedUnitId: null,
      units: [],
      categories: {
        queue: "Filas",
        attendance: "Atendimento",
        medical_request: "Solicitação médica",
        configuration: "Configurações",
        patient: "Paciente",
      },
    };
  },
  created() {
    const cached = JSON.parse(localStorage.getItem("units_cache") || "null");
    const now = new Date();

    if (cached && new Date(cached.expires_at) > now) {
      this.units = cached.units;
    } else {
      this.$apollo.query({ query: require("@/graphql/unit/units.gql") })
        .then(({ data }) => {
          this.units = data.units;
          localStorage.setItem("units_cache", JSON.stringify({
            units: data.units,
            expires_at: new Date(now.getTime() + 24 * 60 * 60 * 1000) // +24h
          }));
        })
        .catch(() => {
          this.error = "Erro ao carregar unidades.";
        });
    }
  },

  apollo: {
    permissions: {
      query: require("@/graphql/permission/permissions.gql"),
      pollInterval: 20000,
    },
    user: {
      query: require("@/graphql/user/user.gql"),
      variables() {
        return {
          userId: this.userId,
        };
      },
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    refreshUser() {
      return this.$apollo.queries.user.refetch();
    },
    saveAllUserPermisssions() {
      return this.apolloMutate({
        mutation: require("@/graphql/user_permission/save_all_user_permissions.gql"),
        variables: {
          userId: this.user.id,
          unitId: this.selectedUnitId, 
        },
      }).then(() => {
        this.refreshUser();
      });
    },
    deleteAllUserPermisssions() {
      return this.apolloMutate({
        mutation: require("@/graphql/user_permission/delete_all_user_permissions.gql"),
        variables: {
          userId: this.user.id,
          unitId: this.selectedUnitId, 
        },
      }).then(() => {
        this.refreshUser();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
